export const PAGE_ROUTES = {
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  RECRUITER_SIGN_UP: '/signup/recruiter',
  MANAGER_SIGN_UP: '/signup/manager',
  FORGOT_PASSWORD: '/forgot-password',
  EMAIL_VERIFICATION: '/email-verification',
  HOME: '/',
  LOGOUT: '/logout',
  COMPANY: '/company',
  MESSAGES: '/messages',
  CAMPAIGNS: '/campaigns',
  APPLICANTS: '/applicants',
  JOBS_CREATE: '/jobs/create',
  JOBS_EDIT: '/jobs/[id]/edit',
  INTERNSHIPS_CREATE: '/internships/create',
  INTERNSHIPS_EDIT: '/internships/[id]/edit',
  COMPETITIONS_CREATE: '/competitions/create',
  COMPETITIONS_EDIT: '/competitions/[id]/edit',
  EVENTS_CREATE: '/events/create',
  EVENTS_EDIT: '/events/[id]/edit',
  STUDENT_SOCIETIES: '/student-societies',
  SOCIETIES: '/societies',
  UNIVERSITIES: '/universities',
  SOCIETIES_SIGNUP: '/signup',
  DASHBOARD: '/dashboard',
  QR_CODE: '/qr-code',
  SOCIETY_PROFILE: '/society-profile',
};
